module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, formatter;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='list-item-wrapper'>\n  <div class='avatar-presenter list-item'>");
      if (this.asset.get("persisted")) {
        if (this.asset.hasThumbnail()) {
          $o.push("    <a class='asset-tint avatar-wrapper square' href='" + ($e($c(this.asset.get("url")))) + "' title='" + ($e($c(this.asset.get("title")))) + "' data-file='" + ($e($c(this.asset.get("title")))) + "'>\n      <img class='avatar' src='" + ($e($c(this.asset.get("thumb")))) + "'>\n    </a>");
        } else {
          $o.push("    <div class='avatar-wrapper square'>\n      <div class='avatar icon icon-file'></div>\n    </div>");
        }
        $o.push("    <div class='include-right-content presenter-wrapper'>\n      <div class='table'>\n        <div class='column delete-confirmation-wrapper file-name'>");
        $o.push("          " + $e($c(this.asset.get("title"))));
        $o.push("          <span class='icon icon-x js-delete' href='javascript:;' data-behavior='confirm-delete'></span>\n          <div class='delete-confirmation'>\n            Are you sure?\n            <a class='js-cancel-delete pipe-separated' href='javascript:;' data-behavior='cancel-delete'>Cancel</a>\n            <a class='js-remove-asset pipe-separated' href='javascript:;'>Delete</a>\n          </div>\n          <div class='delete-replace file-size subtext'>\n            <span class='js-file-metadata'>");
        formatter = new this.FormattedNumber(this.asset.get("filesize"));
        $o.push("              " + $e($c(formatter.friendlyFileSize())));
        $o.push("            </span>\n          </div>\n        </div>\n        <div class='column created-by'>");
        $o.push("          " + $e($c(this.asset.get("createdBy"))));
        $o.push("        </div>\n        <!-- *TODO make relative time ago*/ -->\n        <div class='column'>\n          <div class='subtext timestamp tooltip-hover'>\n            <div class='friendly'>\n              Just now\n            </div>\n          </div>\n        </div>\n      </div>\n      <a class='button download-asset right-content secondary small' href='" + ($e($c(this.asset.get("url")))) + "' target='_blank' title='Download'>\n        <span class='icon icon-cloud-download'></span>\n      </a>\n    </div>");
      } else {
        $o.push("    <span class='icon icon-spinner js-processing'>Processing</span>");
      }
      $o.push("  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/assets/story_assets_tab_asset.js.hamlc
// module id = 1697
// module chunks = 17